import React, { useCallback, useEffect, useState } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/tableStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import Overlay from '../../components/Overlay/Overlay';
import { Dialog } from '@material-ui/core';
import RegularButton from '../../components/CustomButtons/Button';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import Variants from './ItemDetailDrawer/Variants';
import Pricing from './ItemDetailDrawer/Pricing';
import {
  getVendorProduct,
  updateVendorProduct,
  addVendorProduct
} from '../../api/index';
import { SecondaryH5, H4 } from 'text';

class PricingModal extends React.Component {
  state = {
    error: null,
    loading: false,
    product: {},
    price: '',
    productHasPricing: false
  };

  loadPricingData = skuId => {
    if (skuId) {
      this.setState({ loading: true });
      getVendorProduct(skuId)
        .then(res => {
          let product = res.data[0];
          if (product) {
            if (product.price) {
              this.setState({ productHasPricing: true });
            }
            this.setState({ product, price: product.source_price });
          }
          this.setState({ loading: false });
        })
        .catch(err => {
          console.error(err);
          this.setState({ loading: false });
        });
    }
  };


  handleAddVendorProduct = (payload, storeId) => {
    const { closePricingModal, updateLocal, activeStore, idx} = this.props;
    addVendorProduct(storeId)(payload)
      .then(res => {
        updateLocal(idx, `${activeStore}_price`, payload.price);
        updateLocal(idx, `${activeStore}_buy_price`, payload.price);
        updateLocal(idx, `${activeStore}_qty`, `1`);
        updateLocal(idx, "retailer_disabled", false);
        this.setState({ loading: false });
        closePricingModal();
      })
      .catch(err => {
        console.log(err);
        this.setState({ loading: false });
        closePricingModal();
      });
  };

  editPricing = (payload, sku) => {
    const { closePricingModal, updateLocal, activeStore, idx } = this.props;
    updateVendorProduct(sku)(payload)
      .then(res => {
        updateLocal(idx, `${activeStore}_buy_price`, payload.price);
        closePricingModal();
      })
      .catch(err => {
        console.log(err)
        this.setState({ loading: false });
      });
  };

  submit = () => {
    const { price, product, productHasPricing } = this.state;
    const { activeStore } = this.props;
    const priceAsNumber = parseFloat(parseFloat(price).toFixed(2));
    const payloadNewProductVariant = {
      price: priceAsNumber
    };
    const payloadNewProduct = {
      ...product,
      price: priceAsNumber
    };
    this.setState({ loading: true }, () => {
      if (productHasPricing) {
        this.editPricing(
          payloadNewProductVariant,
          product.sku_id
        );
      } else {
        this.handleAddVendorProduct(payloadNewProduct, activeStore);
      }
    });
  };

  componentDidMount() {
    const { skuId } = this.props;
    this.loadPricingData(skuId);
  }

  setPrice = price => {
    this.setState({ price });
  };

  render() {
    const { loading, error, product, price,  } = this.state;
    const { open, closePricingModal, isAddingNewItem } = this.props;
    return (
      <Dialog open={open} onBackdropClick={closePricingModal}>
        {loading && <Overlay type="loading" />}
        {error && (
          <Overlay
            type="error"
            message={error}
            dismiss={
              <RegularButton
                size="sm"
                color="primary"
                onClick={() => {
                  this.setState({ error: null });
                }}
              >
                Dismiss
              </RegularButton>
            }
          />
        )}
        <div style={{ padding: 20 }}>
          <Grid
            container
            spacing={3}
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item xs={6}>
              <img src={product.image} style={{ maxWidth: '200px' }} />
            </Grid>
            <Grid item xs={6}>
              <SecondaryH5>{product.title}</SecondaryH5>
              <H4>{product.subtitle}</H4>
              {product && product.volume_variants && (
                <Variants
                  variants={product.volume_variants}
                  sku={product.sku_id}
                  loadProductData={this.loadPricingData}
                />
              )}
              <Pricing canEdit={true} price={price} setPrice={this.setPrice} />

              <RegularButton
                size="sm"
                color="primary"
                onClick={() => {
                  this.submit();
                }}
              >
                {isAddingNewItem ? "Add to my inventory" : "Edit Price"}
              </RegularButton>
            </Grid>
          </Grid>
        </div>
      </Dialog>
    );
  }
}

export default connect(state => ({
  activeStore: state.app.activeStore
}))(withStyles(styles)(PricingModal));
